import React from 'react';
import { Formik, Form } from 'formik';
import { Box, Button, Container, Typography } from '@mui/material';
import { TextInput } from '../../shared/textInput/textInput';
import { ImageUploader } from '../../shared/ImageUploader/imageUploader';
import { AutoCompleteInput } from '../../shared/autoComplete/autoCompleteInput';
import { User } from '../../../interfaces/entities/user';
import { employeeValidationSchema } from '../../../validationSchema/employeeValidationSchema';
import { UserRoles } from '../../../enums/userRoles.enum';

interface EmployeeFormProps {
  title: string;
  initialValues: User;
  onSubmit: (values: any) => Promise<void>;
  onImageChange: (file: File | null) => void;
  companyOptions: { id: string; label: string }[];
  branchOptions: { id: string; label: string }[];
  isSubmitting?: boolean;
  onCancel?: () => void;
}

export const EmployeeForm: React.FC<EmployeeFormProps> = ({
  title,
  initialValues,
  onSubmit,
  onImageChange,
  companyOptions,
  branchOptions,
  isSubmitting = false,
  onCancel
}) => {

  const handleSubmitClick = (values: User, actions: any) => {
    handleFormSubmit(values, actions);
  };

  // Wrapper to handle form submission from Formik
  const handleFormSubmit = async (values: User, actions: any) => {
    await onSubmit(values);
    actions.setSubmitting(false);
  };
 
  return (
    <Box>
      <Container maxWidth="sm" className="branch-form-container">
        <div style={{ padding: '1rem', borderRadius: '8px' }}>
          <Typography variant='h5'>{title}</Typography>
          <Formik
            initialValues={initialValues}
            validationSchema={employeeValidationSchema}
            onSubmit={(values, actions) => handleSubmitClick(values, actions)}
            validateOnMount={true}
          >

            {({ values, isValid, errors, touched, setFieldValue }) => (
              <Form>

                <AutoCompleteInput
                  label="Company"
                  onChange={setFieldValue}
                  options={companyOptions}
                  required
                  name={'companyId'}
                  disabled={true}
                />

                {initialValues.role === UserRoles.employee && <AutoCompleteInput
                  label="Branch"
                  onChange={setFieldValue}
                  options={branchOptions}
                  required
                  name={'branchId'}
                />
                }

                <TextInput
                  label=" First Name"
                  name="firstName"
                  errorText={errors.firstName && touched.firstName ? errors.firstName : ""}
                  disabled={isSubmitting}
                />
                <TextInput
                  label="Last Name"
                  name="lastName"
                  errorText={errors.lastName && touched.lastName ? errors.lastName : ""}
                  disabled={isSubmitting}
                />
                <TextInput
                  label="Email"
                  name="email"
                  errorText={errors.email && touched.email ? errors.email : ""}
                  disabled={isSubmitting}
                />
                <TextInput
                  label="Contact Number"
                  name="contact"
                  errorText={errors.contact && touched.contact ? errors.contact : ""}
                  disabled={isSubmitting}
                />
                <TextInput
                  label="Employee No"
                  name="empNo"
                  errorText={errors.empNo && touched.empNo ? errors.empNo : ""}
                  disabled={isSubmitting}
                />
                <TextInput
                  label="Address"
                  name="address"
                  errorText={errors.address && touched.address ? errors.address : ""}
                  disabled={isSubmitting}
                />
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                  Employee Image
                </Typography>
                <ImageUploader
                  name="image"
                  uploadedUrl={values.image}
                  onChange={onImageChange}
                  disabled={isSubmitting}
                />
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!isValid || isSubmitting}
                    fullWidth
                    className="register-button"
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={onCancel}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    Cancel
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </div>
      </Container>
    </Box>
  );
};
